import React, { FC } from 'react'
import GeneralForm from '../../../Form'
import {
  TAttachmentIds,
  TChangeAttachmentExtrafieldPayload,
  TFieldChangePayload
} from '../../../../store/managePost/newTypes'
import { ATTACHMENT_EXTRAFIELD, SOCIAL_NETWORK } from '../../../../models/post'
import TextInput from '../../../UI/Inputs/TextInput'
import { FormikHelpers } from 'formik'

interface VideoTitleInputProps {
  isEditable: boolean
  setExtraField: (data: TChangeAttachmentExtrafieldPayload) => void
  value: string | undefined
  attachmentIds: TAttachmentIds
  social: SOCIAL_NETWORK
  className: string
}

const VideoTitleInput: FC<VideoTitleInputProps> = ({
  className,
  social,
  value,
  isEditable,
  attachmentIds,
  setExtraField
}) => {
  const setupForm = {
    initialValues: { video_title: value || '' },
    validation: 'post',
    enableReinitialize: true,
    onSubmit: async (values: any, actions: FormikHelpers<any>) => {}
  }

  const setExtraVideoTitle = (value: string) => {
    setExtraField({ ...attachmentIds, field: ATTACHMENT_EXTRAFIELD.TITLE, value })
  }

  return (
    <div className={className}>
      <GeneralForm {...setupForm}>
        <TextInput
          disabled={!isEditable}
          name='video_title'
          placeholder='Type a video title...'
          customOnBlur={setExtraVideoTitle}
          social={social}
        />
      </GeneralForm>
    </div>
  )
}

export default VideoTitleInput
